import {getCurrentUserLogin} from '@github-ui/client-env'
import type {CompletedReview} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'

import {useLayoutRouteData} from '../../../../page-data/loaders/use-layout-route-data'
import {PullRequestState} from '../../../../types'
import {useReviewers} from '../../data/use-reviewers'

export type ReviewQueryResult = {
  data: CompletedReview | null
  queryStatus: 'loading' | 'error' | 'missing' | 'success'
}

export function selectReview(completedReviews: CompletedReview[], viewerLogin: string): CompletedReview | null {
  return (
    completedReviews.find(
      review => review.reviewer?.reviewerType === 'User' && review.reviewer.displayLogin === viewerLogin,
    ) ?? null
  )
}

export function useReviewData(): ReviewQueryResult {
  const {pullRequest} = useLayoutRouteData()
  const {data: reviewers, isError, isLoading} = useReviewers()
  const viewerLogin = getCurrentUserLogin()

  if (!viewerLogin || pullRequest.state !== PullRequestState.Open) {
    return {data: null, queryStatus: 'success'}
  }

  if (!reviewers) {
    return {data: null, queryStatus: isLoading ? 'loading' : isError ? 'error' : 'missing'}
  }

  return {data: selectReview(reviewers.completedReviews, viewerLogin), queryStatus: 'success'}
}
